export default __webpack_public_path__ + "static/media/Hair_4_M_C1.bfdf1b81.svg";